import type { Match } from '@atlassian/react-resource-router';

export const DEFAULT_PREFETCH_MAX_AGE: number = 10 * 1000;

export const getExpiresAt = (): number => DEFAULT_PREFETCH_MAX_AGE + Date.now();

export const isExpired = (expiresAt: number): boolean => expiresAt < Date.now();

type ObjectToCompare = Record<string, string | null | undefined>;

const isShallowEqual = (o1: ObjectToCompare, o2: ObjectToCompare) => {
	const objKeys1 = Object.keys(o1);
	const objKeys2 = Object.keys(o2);

	if (objKeys1.length !== objKeys2.length) return false;

	return objKeys1.every((key) => o1[key] === o2[key]);
};

export const isSameRouteMatch = ({
	prevContextMatch,
	nextContextMatch,
}: {
	prevContextMatch: Match;
	nextContextMatch: Match;
}): boolean =>
	prevContextMatch.path === nextContextMatch.path &&
	isShallowEqual(prevContextMatch.query, nextContextMatch.query) &&
	isShallowEqual(prevContextMatch.params, nextContextMatch.params);
